import { render } from "./VetDashboard.vue?vue&type=template&id=e1ef374a&scoped=true"
import script from "./VetDashboard.vue?vue&type=script&lang=js"
export * from "./VetDashboard.vue?vue&type=script&lang=js"

import "./VetDashboard.vue?vue&type=style&index=0&id=e1ef374a&lang=css"
import "./VetDashboard.vue?vue&type=style&index=1&id=e1ef374a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1ef374a"]])

export default __exports__